import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

const AuditTypes = () => (
  <div>
    <Breadcrumbs crumbs={[{title: 'Categories'}]}/>
    <Paper>
      <Table/>
    </Paper>
  </div>
);

export default AuditTypes;
